/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Content, ContentType, LicenseType, ListAllContentResponse } from '../../../interface';
import { HibraryRootState } from '../../../redux/rootReducer';
import { BreadcrumbLink, BreadCrumbView } from '../../components/breadcrumb';
import { MemoContentCollectionView } from '../../components/contentCover';
import { EmptyDataView } from '../../components/nodata';
import { Loading } from '../../customUI/loading';
import { removeSplash } from '../../helpers/removeSplash';
import { action } from '../../redux/request';
import { getCustomContents } from '../../redux/store/storeCrud';
import { useIntl } from 'react-intl';
import './index.scss';

interface RentableContentsProps {
    contentType: ContentType;
    licenseType: LicenseType;
    segmentUID: string;
}

const CustomContent = (props: RentableContentsProps) => {
    const { contentType, licenseType, segmentUID } = props;
    const intl = useIntl();
    const pageId = 'RentableContents';
    const dispatch = useDispatch();
    const [title, setTitle] = useState<string>();
    const [contents, setContents] = useState<ListAllContentResponse>();
    const [breadCrumbs, setBreadCrumbs] = useState<BreadcrumbLink[]>();

    const { environment, clientInfo, authen, request } = useSelector(
        (state: HibraryRootState) => ({
            clientInfo: state.clientInfo,
            authen: state.auth,
            environment: state.environment,
            request: state.fetch
        }),
        shallowEqual
    );

    const breadcrumbs = useMemo(() => {
        return <BreadCrumbView addLinks={breadCrumbs} />;
    }, [breadCrumbs]);

    useEffect(() => {
        fetchRentableContents(false);
    }, []);

    useEffect(() => {
        if (environment.endOfScreen) {
            if (contents?.lastEvaluatedKey !== undefined && !request.loading) {
                fetchRentableContents(true);
            }
        }
    }, [environment]);

    const fetchRentableContents = async (isEndless: boolean) => {
        try {
            dispatch(action.setProcess(true, pageId));
            const lastEvaluatedKey = isEndless ? contents?.lastEvaluatedKey : undefined;
            const response = await getCustomContents(
                authen.isLogin,
                clientInfo.companyPrefix,
                segmentUID,
                lastEvaluatedKey as string
            );
            if (response) {
                if (isEndless && contents?.contents) {
                    setContents({
                        ...contents,
                        contents: contents.contents.concat(response.contents),
                        lastEvaluatedKey: response.lastEvaluatedKey ?? undefined
                    });
                } else {
                    setTitle(response.title as string);
                    setContents(response);
                    setBreadCrumbs([
                        {
                            title: response.title as string
                        }
                    ]);
                }
            }
        } finally {
            dispatch(action.setProcess(false, pageId));
            dispatch(removeSplash);
        }
    };

    return (
        <>
            {breadcrumbs}
            <div className='view-all-content'>
                <h1 className='viewAllTitle'>{title || 'ไม่พบข้อมูล'}</h1>
                {contents?.contents && contents.contents.length > 0 ? (
                    <div className='content-list content-list-container-ebook'>
                        {contents?.contents.map((el) => (
                            <MemoContentCollectionView
                                content={el as Content}
                                licenseType={el.licenseType}
                            />
                        ))}
                    </div>
                ) : (
                    !request.loading && <EmptyDataView />
                )}
            </div>
            <Loading id={pageId} />
        </>
    );
};

export default CustomContent;
